import { gql } from 'graphql-request';
import { SurveyDesign } from 'src/shared/types';

const surveyDesignFields = `
    customerName
    projectId
    projectName
    projectCode
    projectType
    area
    country
    targetOutcome
    projectOutline
    surveyPublishDate
    surveySamples {
        sampleId
        samplePoint
        sampleGroup
        kitType
        latitude
        longitude
        habitatAssayTypes {
            habitatName
            assayName
            habitatAssayKey
        }
    }
    habitatAssayTypes {
        habitatName
        assayName
        habitatAssayKey
    }
    samplingCadence {
        type
        samplingEventsPerYear
        events {
            name
            fromDate
            toDate
        }
    }
    sampleGroups
    speciesOfInterest
    leadName
    leadEmail
    leadRole
    subscriptionType
    subscription {
        name
        label
    }
    createdAt
    creatorName
    status
`;

export const surveyDesignsQuery = gql`
    query getSurveyDesignList($customerId: String!, $surveyDesignStatus: ProgressStatus) {
        listSurveyDesigns(customerId: $customerId, progressStatus: $surveyDesignStatus) {
            projectId
            projectName
            projectCode
            country
            surveyPublishDate
            createdAt
            creatorName
            status
            subscriptionType
            subscription {
                name
                label
            }
        }
    }
`;

export const surveyDesignQuery = gql`
    query getSurveyDesign($projectId: String!) {
        surveyDesign(projectId: $projectId) {
            ${surveyDesignFields}
        }
    }
`;

export type SurveyDesignsQueryResult = {
    listSurveyDesigns: SurveyDesign[];
};

export type SurveyDesignQueryResult = SurveyDesign;
